import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Header_User from './../user/Header_User';
import { Link } from 'react-router-dom';
import API from './../../api';
import { BiBook } from 'react-icons/bi';
import { AiOutlineUser, AiOutlineShoppingCart, AiOutlineArrowUp, AiOutlineHome, AiOutlineMenu } from 'react-icons/ai'; // Import de l'icône Home
import { FaGlobe, FaExternalLinkAlt } from "react-icons/fa";
import './admin-header.css';
import './admin-header.css'
const AdminHeader = React.memo(() => {
  const user = useSelector((state) => state.user);
  const config = useSelector((state) => state.config);
  const { t } = useTranslation();
  const navLinks = [];

  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <header className={`App-header ${menuOpen ? 'responsive-menu-on' : ''}`} id="admin-header">
      <div id="header-main" className=''>
        <div className="col  py-1 text-start" id="header-main-left" >
          <Link className="logo" to="/admin">
            <img src="/img/logo.png" alt="" style={{ maxHeight: "60px" }} />
          </Link>
        </div>
        <div className="col " id="header-main-center">
          <Link to={'/admin'} className="fs-3 text-gray-9 text-uppercase" >Backoffice</Link>
          {/* Burger Menu for mobile */}
          {/* Navigation links with toggle for mobile */}
          <nav className={`nav-links ${menuOpen ? 'active' : ''}`}>
            {navLinks.map((link, index) => (
              <Link to={link.to} className="btn btn-green" key={index}>
                {link.icon}
              </Link>
            ))}
          </nav>
        </div>
        <div className="" id="header-main-right" >
          <div className='d-flex justify-content-end gap-2 align-items-center' >
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Voir le site public"
              title="Voir le site public"
              className='text-primary'
            >
              <FaGlobe size={24} />
            </a>
            <Header_User />
          </div>
        </div>
      </div>

      <button className="burger-menu" onClick={toggleMenu}>
        <AiOutlineMenu size={30} />
      </button>
      <div id="header-responsive-menu">
        <ul className="list-unstyled">
          {navLinks.map((item, index) => (
            <li className="py-2" key={index}>
              <Link to={item.to} className="" onClick={() => setMenuOpen(false)}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </header >
  );
});
export default React.memo(AdminHeader);
